import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { drjInfo, drjInfoAlabang, pcwExperience } from "common";
import { ActiveBranch, CompanyInfoBranches } from "./types";
import * as thunks from "./thunks";

const branchesList = [drjInfo, drjInfoAlabang, pcwExperience];

type State = {
  branches: CompanyInfoBranches[];
  currentBranch: ActiveBranch;
  defaultBranch: ActiveBranch;
  userBranchOptions: ActiveBranch[];
  branchOptionsLoading: boolean;
  doNotShowAgain: boolean;
};

const initialState: State = {
  branches: branchesList,
  currentBranch: {},
  defaultBranch: {},
  userBranchOptions: [],
  branchOptionsLoading: false,
  doNotShowAgain: false,
};

const setCurrentBranch = (
  state: State,
  { payload }: PayloadAction<ActiveBranch>
) => {
  state.currentBranch = { ...payload };
};

const setDefaultBranch = (
  state: State,
  { payload }: PayloadAction<ActiveBranch>
) => {
  state.defaultBranch = { ...payload };
};

const setDoNotShowAgain = (state: State) => {
  state.doNotShowAgain = true;
};

const slice = createSlice({
  name: "Branch",
  initialState,
  reducers: { setCurrentBranch, setDoNotShowAgain, setDefaultBranch },
  extraReducers(builder) {
    builder.addCase(thunks.getActiveBranchesThunk.pending, (state) => {
      state.branchOptionsLoading = true;
    });
    builder.addCase(
      thunks.getActiveBranchesThunk.fulfilled,
      (state, { payload }) => {
        const { data: options, success } = payload.originalData;
        if (success && options[0]) {
          state.userBranchOptions = options || [];
          state.defaultBranch = options.find((option) => option?.is_default);
        } else {
          console.error("Failed at getActiveBranchesThunk");
        }
        state.branchOptionsLoading = false;
      }
    );
  },
});

export const reducer = slice.reducer;
export const actions = { ...slice.actions, ...thunks };
